import { render, staticRenderFns } from "./ClipboardAdd.vue?vue&type=template&id=1af0ecb0&scoped=true"
import script from "./ClipboardAdd.vue?vue&type=script&lang=js"
export * from "./ClipboardAdd.vue?vue&type=script&lang=js"
import style0 from "./ClipboardAdd.vue?vue&type=style&index=0&id=1af0ecb0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1af0ecb0",
  null
  
)

export default component.exports